export const LANGS = ['zh-Hant', 'zh-Hans', 'en'] as const;
export type Lang = (typeof LANGS)[number];

/** Content typed by a brand in several languages; a missing key means "not translated". */
export type LocalizedText = Partial<Record<Lang, string>>;

export const LANG_META: Record<Lang, { label: string; short: string; slug: string; htmlLang: string }> = {
  'zh-Hant': { label: '繁體中文', short: '繁', slug: 'zh-hant', htmlLang: 'zh-Hant-HK' },
  'zh-Hans': { label: '简体中文', short: '简', slug: 'zh-hans', htmlLang: 'zh-Hans' },
  en: { label: 'English', short: 'EN', slug: 'en', htmlLang: 'en' },
};

export function isLang(value: unknown): value is Lang {
  return typeof value === 'string' && (LANGS as readonly string[]).includes(value);
}

export function langFromSlug(slug: string | undefined | null): Lang | null {
  if (!slug) return null;
  const lower = slug.toLowerCase();
  return LANGS.find((l) => LANG_META[l].slug === lower) ?? null;
}

/**
 * Text in `lang`, else the first non-empty of `fallbacks`, else any non-empty translation.
 * Pass the brand's default language as the first fallback.
 */
export function pickText(text: LocalizedText | null | undefined, lang: Lang, fallbacks: readonly Lang[] = []): string {
  if (!text) return '';
  for (const l of [lang, ...fallbacks]) {
    const v = text[l];
    if (v && v.trim()) return v;
  }
  for (const l of LANGS) {
    const v = text[l];
    if (v && v.trim()) return v;
  }
  return '';
}
